import axios from 'axios';
import * as types from '@/store/types';

export default {
  saveToken ({ commit }, token) {
    commit(types.SAVE_TOKEN, token);
  },
  async updateState ({ commit }) {
    try {
      await axios.get('/api/web/state_chat');
      return true;
    } catch (e) {
      return null;
    }
  },
  updateCallState({ commit }, params) {
    commit(types.STATE_CALL, { params });
  }
};
